/** What people come for. A place can be coffee by day and a bar at night. */
export enum EstablishmentOfferEnum {
    COFFEE = 'coffee',
    BREAKFAST = 'breakfast',
    FOOD = 'food',
    BAR = 'bar',
    WINE = 'wine',
    MUSIC = 'music',
    MARKET = 'market',
}

export const ESTABLISHMENT_OFFER_ORDER: EstablishmentOfferEnum[] = [
    EstablishmentOfferEnum.COFFEE,
    EstablishmentOfferEnum.BREAKFAST,
    EstablishmentOfferEnum.FOOD,
    EstablishmentOfferEnum.BAR,
    EstablishmentOfferEnum.WINE,
    EstablishmentOfferEnum.MUSIC,
    EstablishmentOfferEnum.MARKET,
];
